import { FormSectionModel, FromSectionContext } from './../../../../../../../models/multiple-sections-form';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedPortalViewService } from '../../../shared-portal-view.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SetWebsiteIdentityRequestBody, WebsiteIdentity } from '../../../../portal.model';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectWebsiteIdentity } from 'src/app/shared/store/_features/website/website.selector';
import { ToastrService } from 'ngx-toastr';
import { InOutAnimation } from 'src/app/shared/animations/animations';


@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: ['./basic-information.component.css'],
  animations: [InOutAnimation]
})
export class BasicInformationComponent implements OnInit, AfterViewInit {
  loaded: boolean = false;
  processing: boolean = false;
  portalIdentityConfigurationForm = new FormGroup({
    label: new FormControl<string>(null, {
      updateOn: 'change',
      validators: [Validators.required],
    }),
    title: new FormControl<string>(null, {
      updateOn: 'change',
      validators: [Validators.required],
    }),
    description: new FormControl<string>(null, {
      updateOn: 'change',
      validators: [Validators.required],
    }),
    favIcon : new FormControl([], {
      
    }),
    favIcon_id: new FormControl([], {
      updateOn: 'change',
    }),
    logo : new FormControl([], {
      
    }),
    logo_id: new FormControl([], {
      updateOn: 'change',
    }),
    learmo_primary_color: new FormControl(null, {
      updateOn: 'change',
    }),
  });
  
  identity :WebsiteIdentity;

  @ViewChild('EditBasicDetails') EditBaiscDetailsTemplate!: TemplateRef<any>;
  // @ViewChild('EditBranding') EditBrandingTemplate!: TemplateRef<any>;
  // @ViewChild('EditMetaDetails') EditMetaDetailsTemplate!: TemplateRef<any>;
  
  formSections: FormSectionModel[] = [
    {
      title: 'Identity Details',
      template: this.EditBaiscDetailsTemplate,
      templateName: 'EditBaiscDetailsTemplate',

      context: {
        actionsSection: {
          isSaveEnable: false,
          showAlways: false,
          isStick: false
        },
        title: 'Identity Details',
        description: '',
        controls: ['title', 'description'],
      },
    },
    // {
    //   title: 'Logo & Branding',
    //   template: this.EditBrandingTemplate,
    //   templateName: 'EditBrandingTemplate',

    //   context: {
    //     actionsSection: {
    //       isSaveEnable: false,
    //       showAlways: true,
    //       isStick: false
    //     },
    //     title: 'Logo & Branding',
    //     description: '',
    //     controls: ['logo','logo_id', 'favIcon','favIcon_id', 'learmo_primary_color'],
    //   },
    // },
  ];

  subscriptions: Subscription[] = []

  constructor(public sharedPortalViewService: SharedPortalViewService, private store: Store, private toastr: ToastrService) { 
    

    this.subscriptions.push(
      this.store.select(selectWebsiteIdentity).subscribe(value=> {
        this.identity = value;
        this.portalIdentityConfigurationForm.patchValue(value, {emitEvent: false});
        this.loaded = true;
      })
    )
  }
  ngAfterViewInit(): void {
    this.formSections.forEach((section) => {
      section.template = this[section.templateName];
    });
  }

  async ngOnInit() {
    // this.loaded = false;
    await this.sharedPortalViewService.getUserDomains();
    this.trackFormChanges();
    // this.loaded = true;
  }


  // loadData() {
  //   this.identity =
  //   JSON.parse(
  //     JSON.stringify(this.sharedPortalViewService.currentWebsite.website.identity));

  //     this.identity.label = this.sharedPortalViewService.currentWebsite.website.label

  //     this.portalIdentityConfigurationForm.patchValue(this.identity)
  // }


  async onSave() {
    
    let payload: SetWebsiteIdentityRequestBody = {
      title: this.portalIdentityConfigurationForm.value.title,
      description: this.portalIdentityConfigurationForm.value.description,
      // label: this.portalIdentityConfigurationForm.value.label,
    }
    this.processing = true;
    await this.sharedPortalViewService.setWebsiteIdentity(payload);
    this.toastr.success('Updated Successfully')
    this.processing = false;

  }


  resetSection(context: FromSectionContext) {
    // 
    Object.keys(this.portalIdentityConfigurationForm.controls).forEach((controlName) => {
      // 
      if (context?.controls?.includes(controlName)) {
        this.portalIdentityConfigurationForm
          .get(controlName)
          ?.setValue(this.identity[controlName], {
            emitEvent: false,
          });
        context.actionsSection.isSaveEnable = false;
      }
    });
  }
  

  trackFormChanges() {
    // this.subscriptions.push(
    //   this.portalIdentityConfigurationForm.valueChanges.subscribe((value) => {
    //     this.sharedProductService.disableNavigate();
    //   })
    // );

    Object.keys(this.portalIdentityConfigurationForm.controls).forEach((controlName) => {
      // 
      this.subscriptions.push(
        this.portalIdentityConfigurationForm
          .get(controlName)
          ?.valueChanges.subscribe((value) => {
            this.formSections.forEach((section) => {
              if (section.context?.controls?.includes(controlName)) {
                section.context.actionsSection.isSaveEnable = true;
              }
            });
            // 
          })
      );
    });
  }

}
